import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { DataCheckerService } from '@tokeet-frontend/tv3-platform'
import { AutomationGuard } from '@tokeet-frontend/automations'
import { SignatureTemplateGuard } from '@tokeet-frontend/signature'
import { DocumentTemplatesComponent } from '@tv3/containers/documents/templates/list/document-templates.component'
import { DocumentAutomationOverlayService } from '@tv3/containers/documents/automations/automation-overlay/document-automation-overlay.service'
import { AmplitudeService } from '@tv3/services/amplitude.service'

@Component({
  selector: 'app-document-automations-overlay',
  templateUrl: './document-automations-overlay.component.html',
  styleUrls: ['./document-automations-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DocumentAutomationsOverlayComponent implements OnInit {
  tab: 'templates' | 'automations' = 'automations'

  @ViewChild('templates') templates: DocumentTemplatesComponent

  constructor(
    public dialogRef: MatDialogRef<DocumentAutomationsOverlayComponent>,
    private dataChecker: DataCheckerService,
    private documentAutomationOverlay: DocumentAutomationOverlayService,
    private amplitudeService: AmplitudeService
  ) {
    this.dataChecker.check([AutomationGuard, SignatureTemplateGuard])
  }

  ngOnInit(): void {
    this.amplitudeService.logEvent('document-automations-overlay-view')
  }

  onAddAutomation() {
    this.amplitudeService.logEvent('document-automations-overlay-add')
    this.documentAutomationOverlay.open()
  }

  close() {
    this.amplitudeService.logEvent('document-automations-overlay-close')
    this.dialogRef.close()
  }
}
